import React, { useEffect, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';
import './Stats.css';

const Stats = () => {
  const { t } = useLanguage();
  const statsRef = useRef([]);
  const hasAnimated = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated.current) {
            hasAnimated.current = true;
            animateCounters();
          }
        });
      },
      { threshold: 0.5 }
    );

    const counterBox = document.querySelector('.counter-box');
    if (counterBox) {
      observer.observe(counterBox);
    }

    return () => {
      if (counterBox) observer.unobserve(counterBox);
    };
  }, []);

  const animateCounters = () => {
    statsRef.current.forEach((counter) => {
      if (!counter) return;

      const target = parseInt(counter.getAttribute('data-target'));
      const duration = 2000;
      const increment = target / (duration / 16);
      let current = 0;

      const updateCounter = () => {
        current += increment;
        if (current < target) {
          counter.textContent = Math.ceil(current);
          requestAnimationFrame(updateCounter);
        } else {
          counter.textContent = target;
        }
      };

      updateCounter();
    });
  };

  return (
    <>
      <div style={{ clear: 'both' }} />
      <div className="counter-box">
        <div className="row counter-box-wrap">
          <div className="counter-box-item">
            <i className="color fa fa-pie-chart" />
            <h1 className="counter-sora" data-target="250" ref={(el) => (statsRef.current[0] = el)}>
              0
            </h1>
            <div className="counter-sora-text">{t.stats.tradingVolume}</div>
          </div>

          <div className="counter-box-item">
            <i className="color fa fa-check-circle" />
            <h1 className="counter-sora" data-target="850" ref={(el) => (statsRef.current[1] = el)}>
              0
            </h1>
            <div className="counter-sora-text">{t.stats.consultingCompanies}</div>
          </div>

          <div className="counter-box-item">
            <i className="color fa fa-book" />
            <h1 className="counter-sora" data-target="50000" ref={(el) => (statsRef.current[2] = el)}>
              0
            </h1>
            <div className="counter-sora-text">{t.stats.trainees}</div>
          </div>

          <div className="counter-box-item">
            <i className="color fa fa-home" />
            <h1 className="counter-sora" data-target="20000" ref={(el) => (statsRef.current[3] = el)}>
              0
            </h1>
            <div className="counter-sora-text">{t.stats.realEstateUnits}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Stats;
